import { observable, action, computed } from 'mobx';
import { handleMessages } from '../util';

// Container Store
export default class ContainerStore {
  @observable label = null;
  @observable calculation = new Map();
  @observable grandTotalIncl = null;
  @observable orderable = null;
  @observable isOrderAvailable = null;
  @observable isOfferAvailable = null;
  @observable positionCount = 0;
  @observable html = '';
  @observable editMode = false;

  pendingRequests = new Map();

  @computed get noEditMode() {
    return !this.editMode;
  }

  @computed get isEmpty() {
    return this.positionCount === 0;
  }

  @computed get hasPositions() {
    return this.positionCount > 0;
  }

  @computed get notOrderable() {
    return this.orderable === null ? null : !this.orderable;
  }

  @computed get isOrderNotAvailable() {
    return this.isOrderAvailable === null ? null : !this.isOrderAvailable;
  }

  @computed get isOfferNotAvailable() {
    return this.isOfferAvailable === null ? null : !this.isOfferAvailable;
  }

  update(data) {
    this.positionCount = data.container ? data.container.position_count : 0;

    if (data.calculation) {
      this.calculation.replace(data.calculation);
      this.orderable = data.calculation.orderable;
      this.isOrderAvailable = data.calculation.is_order_available;
      this.isOfferAvailable = data.calculation.is_offer_available;

      if (data.calculation.grand_total_incl !== undefined) {
        this.grandTotalIncl = data.calculation.grand_total_incl;
      }
    }
    if (data.html !== undefined) {
      this.html = data.html;
      this.editMode = false;
    }
    if (data.container) {
      this.label = data.container.label;
    }
    if (data.post_reveal) {
      $(data.post_reveal).foundation().foundation('open');
    }

    if (data.tracking_event_data) {
      if (window.emos3 && data.tracking_event_data.econda) {
        window.emos3.send(data.tracking_event_data.econda);
      }
      if (window.gtag && data.tracking_event_data.analytics) {
        if (data.tracking_event_data.analytics.event && data.tracking_event_data.analytics.data) {
          window.gtag(
            'event',
            data.tracking_event_data.analytics.event,
            data.tracking_event_data.analytics.data,
          );
        }
      }
    }
  }

  @action
  post(url, formdata) {
    if (!this.pendingRequests.has(url)) {
      this.pendingRequests.set(url, []);
    } else {
      const oldRequest = this.pendingRequests.get(url).slice(-1)[0];
      if (oldRequest) {
        oldRequest.abort();
      }
    }

    const pending = this.pendingRequests.get(url);
    const request = new XMLHttpRequest();
    pending.push(request);

    let contentType = 'application/x-www-form-urlencoded';
    let processData = true;

    if (formdata instanceof FormData) {
      contentType = false;
      processData = false;
    }

    return $.ajax({
      url,
      xhr: () => request,
      method: 'POST',
      data: formdata,
      beforeSend: (req, settings) => {
        // add positions ordering param if defined
        const ordering = $('input[name="ordering"][checked]');
        if (ordering.length && (formdata instanceof FormData || formdata.filter(el => el.name === 'render').length)) {
          const idx = settings.url.indexOf('?');
          const host = idx >= 0 ? settings.url.substr(0, idx) : settings.url;
          const params = new URLSearchParams(idx >= 0 ? settings.url.substr(idx) : '');
          if (ordering) {
            params.set('ordering', ordering.val());
            settings.url = `${host}?${params.toString()}`;
          }
        }
      },
      contentType,
      processData,
    }).then(handleMessages).then((data) => {
      this.update(data);
      return data;
    }).always(() => {
      pending.splice(pending.indexOf(request), 1);
    });
  }

  @action
  setLabel(url, data) {
    return $.ajax({
      url,
      method: 'POST',
      data,
    }).then((response) => {
      if (response.status) {
        this.label = response.label;
      }
      return response;
    });
  }

  @action
  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  @action
  disableEditMode() {
    this.editMode = false;
  }
}
